/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

// eslint-disable-next-line import/no-anonymous-default-export
export default {

  addCorporate: (data) => {
    return axios.post(API_ENDPOINTS.ADD_CORPORATE, data, {
      headers: { isAuthRequired: true, "Content-Type": "multipart/form-data","x-tenant-slug":"default" },
    });
  },
  getCorporateList: (params) => {
    return axios.get(API_ENDPOINTS.GET_ALL_CORPORATE, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
      params,
    });
  },
  getCorporateDetails: (id) => {
    return axios.get(API_ENDPOINTS.GET_CORPORATE_DETAILS_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
    });
  },
  updateCorporate: (id, data) => {
    let url = API_ENDPOINTS.UPDATE_CORPORATE_DETAILS_BY_ID + "/" + id;
    return axios.put(url, data, {
      headers: { isAuthRequired: true, "Content-Type": "multipart/form-data","x-tenant-slug":"default" },
    });
  },
  deleteCorporate: (id) => {
    return axios.delete(API_ENDPOINTS.DELETE_CORPORATE_DETAILS_BY_ID + "/" + id, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
    });
  }
};
